import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';

/**
 * Slide+fade wrapper for one step of a multi-step form. Wrap the whole step set in
 * <AnimatePresence mode="wait"> at the call site is not required — this component owns it, keyed
 * by `stepKey` so only the active step renders/animates at a time.
 */
export default function WizardStep({ stepKey, children }) {
  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={stepKey}
        initial={{ opacity: 0, x: 24 }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: -24 }}
        transition={{ duration: 0.22, ease: 'easeOut' }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
}
